import { DataAccessUtils } from '@assets/model/DataAccessUtils';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import * as style from './DealModalThumbnail.module.less';

interface IDealModalThumbnailProps {
    name: string;
    onSelect?: (dealId: string) => void;
}

export const DealModalThumbnail = observer((p: IDealModalThumbnailProps) => {
    const store = useStore();
    const query = store.createDataAccess(p.name) as DataAccessUtils;

    const companyName = query.value('company_name');
    const industry = query.value('industry');
    const sub_industry = query.value('industrySubType');
    const companyDesc = query.value('company_overview_short');
    const industry_display = sub_industry ? `${industry} - ${sub_industry}` : industry;

    return (
        <div
            className={style.thumb}
            onClick={() => p.onSelect?.(p.name)}
        >
            <Flex direction="column">
                <div className={style.title}>{companyName}</div>
                <div className={style.industry}>{industry_display}</div>
                <div className={style.divider}></div>
                <div className={style.overview}>{companyDesc}</div>
            </Flex>
        </div>
    );
}); 